export default function accountDeleteConfirmation () {
  const elDeleteAccount = document.querySelector('.js-delete-account')

  if (elDeleteAccount) {

    elDeleteAccount.addEventListener('click', (evt) => {

      const response = confirm('Du håller på att radera ditt konto. Detta går inte att ångra. Är du säker?')
      if (!response) {
        evt.preventDefault()
      }
    })
  }
}
